//import AWSMqtt from 'aws-mqtt';
import {safeJSONparse} from "./safeJSONparse";
import Deferred from '../../browser/fw/deferred';

let iotInstance;

class IoT {

	constructor() {
		this.device = null;
		this.config = null;
		this.listeners = [];
		this.connected = false;
	}

	setConfig(config) {
		if (typeof config === 'string') {
			config = safeJSONparse(config);
		}
		this.config = config;

		// for chaining purposes
		return this;
	}

	connect() {
		if (!this.config) {
			new Error('User has to be set in (preferably in root component).');
		}

		if (this.connected) {
			return new Promise((resolve) => {
				resolve();
			});
		}

		if (this.connectingPromise) {
			return this.connectingPromise;
		}

		let self = this;

		this.connectingPromise = new Deferred();

		// do not ivoke aws-sdk for static generated web on web
		// eslint-disable-next-line no-undef
		if (global && global.isNode) {
			return this.connectingPromise.resolve();
		}

		import(/* webpackChunkName: "awsSdkGlobal" */ 'aws-sdk/global').then(({default: AWS}) => {
			let mqttConfig = self.config.mqttConfig;
			mqttConfig.credentials = new AWS.Credentials(self.config.credentials);

			// self.device = AWSMqtt.connect(mqttConfig);

			// self.device.on('connect', () => {
			// 	self.connected = true;
			// 	this.connectingPromise.resolve();
			// });

			// self.device.on('error', (error) => {
			// 	self.device.end();
			// 	self.connected = false;
			// 	this.connectingPromise.reject(error);
			// });

			// // Nothing to do. The aws-mqtt is reconnecting on iself
			// // self.device.on('offline', () => {});

			// self.device.on('message', (topic, message) => {
			// 	let messageObject = safeJSONparse(message.toString());
			// 	self.listeners.forEach((listener) => {
			// 		if (listener.topic === topic) {
			// 			listener.fn.call(listener.stack, messageObject);
			// 		}
			// 	});
			// });
		}).catch((error) => {
			this.connectingPromise.reject(error);
		});

		return this.connectingPromise;
	}

	end() {
		if (this.device && this.device.end) {
			this.device.end();
		}
	}

	getRootTopic() {
		return '/user/' + this.config.userTopicId + '/root/';
	}

	subscribe(path) {
		this.device.subscribe(this.getRootTopic() + path);
	}

	publish(topic, messageObject) {
		topic = topic || '';

		return this.connect().then(() => {
			this.device.publish(this.getRootTopic() + topic, JSON.stringify(messageObject));
		});
	}

	listen(topic, callback, callstack) {
		if (!this.config) {
			throw new Error('IotClient.setConfig(user.iotTopic) has to been set before any websocket listening can be done');
		}
		this.listeners.push({
			topic: this.getRootTopic() + topic,
			fn: callback,
			stack: callstack || {}
		});
		let self = this;
		return this.connect().then(() => {
			self.subscribe(topic);
		});
	}
}

if (!iotInstance) {
	iotInstance = new IoT();
}

export default iotInstance;
